import type { IconData } from '@stacksjs/iconify-core'

export const basicUiDelete2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M6 4L4 6l2 2l-2 2l2 2l2-2l2 2l2-2l-2-2l2-2l-2-2l-2 2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiDelete2
